import React from 'react';
import proptypes from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import {
  ProAlertsAndUpdates as ProAlertsAndUpdatesComponent
} from '@thd-olt-component-react/pro-alerts-and-updates';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { ImpressionProvider } from '@thd-olt-component-react/impression';

const { string } = proptypes;

export function ProAlertsAndUpdates({ id }) {
  const data = {
    id,
    name: 'ProAlertsAndUpdates',
    component: 'ProAlertsAndUpdates',
    type: 'content',
    position: 1,
  };

  return (
    <ErrorBoundary name="pro-alerts-and-updates">
      <QueryProvider cacheKey="pro-alerts-and-updates-cacheKey">
        <ImpressionProvider data={data}>
          <ProAlertsAndUpdatesComponent componentId={id} />
        </ImpressionProvider>
      </QueryProvider>
    </ErrorBoundary>
  );
}

ProAlertsAndUpdates.propTypes = {
  id: string,
};

ProAlertsAndUpdates.defaultProps = {
  id: undefined,
};
